import type { IPropKeysObject, TPayload } from '../../models';

/**
 * Проверяет тип получаемых данных на принадлежность к объекту, иначе кидает ошибку.
 * Функция вынесена отдельно для удобства тестирования.
 *
 * @param payload - данные
 */
export const checkPayloadType = <T = unknown>(payload: T) => {
    if (typeof payload !== 'object') {
        throw new Error(`Payload must be an object. Received ${payload} of type ${typeof payload}`);
    }
};

/**
 * Формирует новый объект пропсов на основе данных из эвент-системы и мета-информации
 *
 * @param payload - данные
 * @param propKeys - набор мета-информации для получения данных из payload и прокидывания в пропсы
 */
export const createPropsByPayload = (payload: TPayload, propKeys: IPropKeysObject[]) => {
    checkPayloadType(payload);

    return propKeys.reduce(
        (state, { dataKey, propKey }) => ({
            ...state,
            [propKey]: payload[dataKey],
        }),
        {}
    );
};
